<template>
  <div class="flex flex-col">
    <MenuItem
      :item="item"
      :refresh-on-navigate="refreshOnNavigate"
      :link-to-new-app="linkToNewApp"
      :secondary="secondary"
    />

    <div class="pl-2 space-y-1 mt-1" v-if="children.length">
      <MenuItem
        v-for="childItem in children"
        :item="childItem"
        :key="childItem.name"
        :refresh-on-navigate="childItem.refreshOnNavigate"
        :link-to-new-app="childItem.linkToNewApp"
        :secondary="childItem.secondary"
      />
    </div>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api'
import MenuItem from './MenuItem.vue'
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    secondary: {
      type: Boolean,
    },
    linkToNewApp: {
      type: Boolean,
      default: false,
    },
    refreshOnNavigate: Boolean,
  },
  setup(props) {
    const goTo = ({ event, href }) => {
      event.preventDefault()
      event.stopPropagation()
      const newHref = props.linkToNewApp ? getNewAppUrl(href) : href
      location.href = getNewAppUrl(newHref)
    }
    const children = computed(() => (props.item && props.item.children) || [])
    return { children, goTo }
  },
  components: { MenuItem },
}
</script>
